import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.substring(1));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const referralEmail = sessionStorage.getItem("eb_ref") || null;
        const { data } = await api.post("/auth/session", { session_id: sessionId, referral_email: referralEmail });
        sessionStorage.removeItem("eb_ref");
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        if (detail && detail.toLowerCase().includes("blocked")) {
          toast.error(detail);
        }
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F2]" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#8C7B6B] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm tracking-[0.2em] uppercase text-[#6E675F]">Signing you in…</p>
      </div>
    </div>
  );
}
